import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const CategoryForm = ({ workspaceId, selectedCategory, setPopupShow, refresh }) => {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (selectedCategory) {
      setName(selectedCategory.name || "");
      setSlug(selectedCategory.slug || "");
      setDescription(selectedCategory.description || "");
    } else {
      setName("");
      setSlug("");
      setDescription("");
    }
  }, [selectedCategory]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("Vui lòng nhập tên category");
      return;
    }
    try {
      setSaving(true);
      const payload = { workspace: workspaceId, name: name.trim(), slug: slug.trim(), description: description.trim() };
      let res;
      if (selectedCategory) {
        res = await Utils._apiRequest({
          path: Enums.endpoints.products.CATEGORY_DETAIL,
          pathParams: { id: selectedCategory._id },
          type: "PUT",
          payload,
        });
      } else {
        res = await Utils._apiRequest({
          path: Enums.endpoints.products.CATEGORIES,
          type: "POST",
          payload,
        });
      }
      if (res.errors) throw new Error(res.errors);
      toast.success(selectedCategory ? "Đã cập nhật category" : "Đã tạo category");
      refresh && refresh();
      setPopupShow(false);
    } catch (err) {
      toast.error(err.message || "Lỗi khi lưu");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Tên category *</Form.Label>
        <Form.Control
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Ví dụ: Leather Wallets"
          autoFocus
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Slug</Form.Label>
        <Form.Control
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder="leather-wallets (tuỳ chọn)"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Mô tả</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Form.Group>
      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={() => setPopupShow(false)} disabled={saving}>
          Huỷ
        </Button>
        <Button variant="primary" type="submit" disabled={saving}>
          {saving ? "Đang lưu..." : selectedCategory ? "Cập nhật" : "Tạo mới"}
        </Button>
      </div>
    </Form>
  );
};

export default CategoryForm;
